export default "__VITE_ASSET__BFIZUipx__"